import {inject, Pipe, PipeTransform} from '@angular/core';
import {Observable} from 'rxjs';
import {DynamicTranslationsStore} from '../stores/dynamic-translations-store';

@Pipe({
  name: 'dynTranslate',
  standalone: true,
  pure: false
})
/**
 * A pipe that dynamically translates a given string key using the `DynamicTranslationsStore`.
 * It can optionally take a `creatorId` to translate the string from the creator's language.
 *
 * Usage:
 * To use this pipe, provide a translation key as the input value and use the async pipe afterwards.
 *
 * Example:
 * <p>{{ 'COMMON.HELLO' | dynTranslate | async }}</p>
 * <p>{{ 'USER.PROFILE_TITLE' | dynTranslate:123 | async }}</p>
 */
export class DynamicTranslatePipe implements PipeTransform {
 private dynamicTranslationsStore: InstanceType<typeof DynamicTranslationsStore> = inject(DynamicTranslationsStore);

  public transform(value: string, creatorId?: number): Observable<string> {
    return this.dynamicTranslationsStore.translate(value, creatorId);
  }

}

